const RESOURCE_NAME = "entities/paymentMethods";

export default {};
